module.exports = __webpack_public_path__ + "static/img/6.ab9beddb.png";